"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterButtonGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_styles_1 = require("@/components/common/button/button.styles");
const icon_names_1 = require("@/components/common/icon/icon-names");
const multiple_selection_controller_1 = require("@/controllers/multiple-selection-controller");
const roving_focus_controller_1 = require("@/controllers/roving-focus-controller");
const single_selection_controller_1 = require("@/controllers/single-selection-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/icon/icon");
let FilterButtonGroup = class FilterButtonGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.mode = 'single';
        this.values = [];
        this.options = [];
        this.orientation = 'horizontal';
        // single/multiple 모드가 런타임에 바뀔 수 있어 두 컨트롤러를 모두 들고 selection에서 mode로 고른다.
        this.singleSelection = new single_selection_controller_1.SingleSelectionController({
            getValue: () => this.values[0] ?? '',
            setValue: value => {
                this.values = value ? [value] : [];
            },
        });
        this.multipleSelection = new multiple_selection_controller_1.MultipleSelectionController({
            getValues: () => this.values,
            setValues: values => {
                this.values = values;
            },
            getOptions: () => this.options,
        });
        // 포커스 이동은 컨트롤러가, 선택은 네이티브 버튼 클릭이 담당한다.
        this.rovingFocus = new roving_focus_controller_1.RovingFocusController(this, {
            getItems: () => Array.from(this.buttons),
            orientation: () => this.orientation,
            getActiveIndex: () => this.options.findIndex(option => this.selection.isOptionSelected(option)),
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'group');
    }
    render() {
        return (0, lit_1.html) `
      ${this.options.map(option => this.renderOption(option))}
    `;
    }
    get selection() {
        if (this.mode === 'multiple')
            return this.multipleSelection;
        return this.singleSelection;
    }
    renderOption(option) {
        const selected = this.selection.isOptionSelected(option);
        const iconName = option.icon ?? (selected ? icon_names_1.ICON_NAMES.CHECK : undefined);
        return (0, lit_1.html) `
      <button
        type="button"
        ?disabled=${option.disabled}
        aria-pressed=${selected ? 'true' : 'false'}
        @click=${() => this.handleOptionClick(option)}
      >
        ${this.renderIcon(iconName)} ${option.label}
      </button>
    `;
    }
    renderIcon(icon) {
        if (!icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${icon}></mm-icon>
    `;
    }
    handleOptionClick(option) {
        if (option.disabled)
            return;
        this.selection.select(option);
        (0, utils_1.emit)(this, 'change', { values: this.values });
    }
};
FilterButtonGroup.styles = [
    shared_styles_1.resetStyles,
    button_styles_1.buttonBaseStyles,
    button_styles_1.buttonSelectedStyles,
    (0, lit_1.css) `
      :host {
        display: flex;
        flex-wrap: wrap;
        gap: var(--space-2);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FilterButtonGroup.prototype, "mode", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], FilterButtonGroup.prototype, "values", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], FilterButtonGroup.prototype, "options", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FilterButtonGroup.prototype, "orientation", void 0);
__decorate([
    (0, decorators_js_1.queryAll)('button')
], FilterButtonGroup.prototype, "buttons", void 0);
FilterButtonGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-filter-button-group')
], FilterButtonGroup);
exports.FilterButtonGroup = FilterButtonGroup;
//# sourceMappingURL=data:application/json;base64,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